module.exports = __webpack_public_path__ + "static/media/signage-indoor-img32.8730125c.jpg";